module.exports = __webpack_public_path__ + "img/gongzidan.14c86de2.svg";